










import {defineComponent} from "@vue/composition-api";
import AuthLayout from "@tool/Layouts/AuthLayout.vue";

export default defineComponent({
    components: {
        AuthLayout,
    },
    props: {
        invitation: {
            type: Object,
            required: true
        }
    }
})
